<template>
  <v-card>
    <!-- <v-card-title class="headline">
      <v-icon left color="blue" large>security</v-icon> FIRMAR DOCUMENTO
    </v-card-title> -->
    <v-alert
      outline
      color="warning"
      v-if="!demofi_ejecutandose"
      :value="true" >
      <h3 class="headline warning--text"><v-icon>warning</v-icon> Atención.-</h3>
      <p>Demofi no se está ejecutando en su equipo o no tiene agregado el certificado de seguridad en su navegador. Haga:</p>
      <p>1. Visite el siguiente enlace para su instalación y/o configuración. Presione <a target="_blank" href="http://test.local.agetic.gob.bo/firmador/#">aquí</a>.</p>
      <p class="margin-0">2. Puede verificar que el certificado de seguridad de Demofi se encuentra instalado. Presione <a href="" @click.prevent="verCertificado()">aquí</a>.</p>
    </v-alert>
    <v-alert
      outline
      color="info"
      icon="info"
      v-if="demofi_ejecutandose && !autenticado"
      :value="true">
      Ingrese el PIN de su Token para poder firmar el grupo de documentos.
    </v-alert>
    <v-alert
      outline
      v-if="certificados.length"
      color="success"
      icon="check"
      :value="true">
      Token iniciado correctamente
    </v-alert>
    <v-card-text>
      <v-container grid-list-md>
        <v-form
          @submit.prevent="autenticar"
          ref="form"
          lazy-validation>
          <v-layout wrap v-if="!autenticado && !$store.state.pin">
            <v-flex xs7>
              <v-text-field
                label="Pin"
                type="password"
                prepend-icon="verified_user"
                :rules="$validate(['required'])"
                v-model="pin"
                :disabled="!token_conectado || autenticado"
              ></v-text-field>
            </v-flex>
            <v-flex xs5>
              <v-btn
                type="submit"
                color="primary"
                :disabled="!token_conectado || autenticado"> Autenticar
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
        <div v-if="certificados.length">
          <h4><v-icon>person</v-icon> Información del Token</h4>
          <div class="demofi-certificado">
            <p><strong>Nombre:</strong> {{ firmador.nombreComunSubject }}</p>
            <p><strong>Organización:</strong> {{ firmador.organizacionSubject }}</p>
            <p><em>Token válido desde el <strong>{{ firmador.inicioValidez }}</strong> hasta el <strong>{{ firmador.finValidez }}</strong></em></p>
          </div>
          <v-select
            label="Certificado"
            :rules="$validate(['required'])"
            v-model="firmadorSeleccionado"
            prepend-icon="person"
            class="p-b-0"
            :disabled="!autenticado"
            item-text="nombreComunSubject"
            item-value="numeroSerie"
            :items="certificados"
          ></v-select>
        </div>
      </v-container>
    </v-card-text>
    <v-card-actions v-show="false">
      <v-layout row>
        <v-flex xs12 center>
          <!-- <v-btn
            @click.native="$store.commit('closeModal',4)">
            <v-icon left>cancel</v-icon>Cancelar
          </v-btn> -->
          <v-btn
            v-if="certificados.length"
            id="btn-demofi-firm-grupal"
            color="success"
            @click="firmar"
            :disabled="!autenticado || firmando">
            <v-icon left>security</v-icon>Firmar</v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>
<script>
  import validate from '@/common/mixins/validate';
  import axios from 'axios';

  export default {
    mixins: [ validate ],
    async created () {
      this.iniciado = false;

      this.solicitud = this.$store.state.selected;

      if (this.solicitud) {
        if (!Array.isArray(this.solicitud)) {
          this.solicitudes = [{
            url_source_pdf: `${this.$apiUrl}eapostilla/apostilla/${this.solicitud.id_archivo}/${this.solicitud.id}`,
            id: this.solicitud.id,
            id_archivo: this.solicitud.id_archivo,
            tramite_solicitante_email: this.solicitud.tramite_solicitante_email,
            nombre_archivo: 'documento.pdf',
            codigo_archivo: 'asada-adas-a-fwq-rfqw-rqasa-wrqw'
          }];
        } else {
          this.solicitudes = [];
          this.solicitud.map(item => {
            console.log('Es item', JSON.stringify(item));
            this.solicitudes.push(
              {
                url_source_pdf: `${this.$apiUrl}eapostilla/apostilla/${item.id_archivo}/${item.id}`,
                id: item.id,
                id_archivo: item.id_archivo,
                tramite_solicitante_email: item.tramite_solicitante_email,
                nombre_archivo: `documento-${item.id_archivo}.pdf`,
                codigo_archivo: `asada-adas-a-fwq-rfqw-rqasa-wrqw - ${item.id_archivo}`
              }
            );
          });
        }
      }

      this.url = `https://localhost:3200`;
      this.urlTokens = `${this.url}/tokens`;
      this.urlStart = `${this.url}/start`;
      this.urlCerts = `${this.url}/certs`;
      this.urlSign = `${this.url}/sign`;
      this.urlFinish = `${this.url}/finish`;
      this.urlKill = `${this.url}/matarProceso`;
      this.verificarTokenConectado();
    },
    data () {
      return {
        url: ``,
        noDemofi: `Demofi no se está ejecutando en su equipo. Verifique que el programa se esté ejecutando en su máquina.`,
        pin: null,
        tokens: [],
        certificados: [],
        firmados: 0,
        iniciado: false,
        iniciando: false,
        firmador: null,
        solicitudes: [],
        autenticado: false,
        autenticando: false,
        firmando: false,
        demofi_ejecutandose: false,
        token_conectado: false,
        boton_autenticar_habilitado: false,
        mostrar_progress: false,
        limite: 0,
        size: 0,
        firmadorSeleccionado: null,
        segmento: true,
        existeCertificados: false
      };
    },
    props: {
      solicitud: {
        type: Array,
        default: () => {}
      },
      onSuccess: {
        type: Function,
        default: null
      }
    },
    methods: {
      listTokens () {
        return new Promise((resolve, reject) => {
          this.$loading.show('Obteniendo información del token 1');
          this.$http.get(this.urlTokens)
            .then(data => {
              this.$loading.hide();
              if (data.finalizado === false) return reject(data);
              return resolve(data);
            })
            .catch(error => {
              return reject({
                finalizado: false,
                mensaje: this.noDemofi,
                data: error
              });
            });
        });
      },
      kill () {
        return axios.get(this.urlKill);
      },
      login (pin) {
        this.$loading.show('Autenticando token');
        return new Promise((resolve, reject) => {
          return axios.get(`${this.urlStart}?pin=${pin}`)
            .then(data => {
              this.$loading.hide();
              if (data.data.finalizado === false) return reject(data);
              else return resolve(data);
            })
            .catch(error => {
              this.$loading.hide();
              return reject({
                finalizado: false,
                mensaje: this.noDemofi,
                data: error
              });
            });
        });
      },
      listCertificates () {
        return new Promise((resolve, reject) => {
          // this.$loading.show('Obteniendo información del token.');
          this.$http.get(this.urlCerts)
            .then(data => {
              if (data.data.finalizado === false) {
                return reject(data);
              }
              return resolve(data.data);
            })
            .catch(error => {
              return reject({
                finalizado: false,
                mensaje: this.noDemofi,
                data: error
              });
            });
        });
      },
      sign (solicitudFirma, aliasParaFirmar, message = '') {
        console.log('Firmando', solicitudFirma.nombre_archivo);
        return new Promise((resolve, reject) => {
          let infoFirma = {
            nombre_archivo: solicitudFirma.nombre_archivo,
            pdf_base64: solicitudFirma.pdf_base64,
            alias: aliasParaFirmar
          };
          this.$loading.show('Firmando documento.' + message);
          return axios.post(this.urlSign, infoFirma,
           {headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(data => {
            this.$loading.hide();
            return resolve(data);
          })
          .catch(error => {
            this.$loading.hide();
            return reject({
              finalizado: false,
              mensaje: `Demofi no se está ejecutando en su equipo.`,
              data: error
            });
          });
        });
      },
      logout () {
        return new Promise((resolve, reject) => {
          return this.$http.get(this.urlFinish)
          .then(data => {
            if (data.finalizado === false) return reject(data);
            return resolve(data);
          })
          .catch(error => reject({
            finalizado: false,
            mensaje: this.noDemofi,
            data: error
          }));
        });
      },
      getFileBase64 (urlFile) {
        console.log('Obteniendo documento', urlFile);
        return new Promise((resolve, reject) => {
          this.$loading.show('Obteniendo documento.');
          this.$http.post(urlFile, this.firmador, {responseType: 'arraybuffer', headers: {Authorization: `Bearer ${this.$storage.get('token')}`}})
            .then(response => {
              this.$loading.hide();
              if (response) {
                let enBase64 = new Buffer(response.data, 'binary').toString('base64');
                return resolve(enBase64);
              } else {
                return reject(new Error('La respuesta es incorrecta'));
              }
            })
            .catch(error => {
              console.log('Error al obtener archivo en base 64: ' + error);
              this.$message.error(error);
              return reject(error);
            });
        });
      },
      verCertificado () { // ------------------------------ COMENZANDO CON LAS PANTALLAS
        const w = 800;
        const h = 400;
        const y = window.outerHeight / 2 + window.screenY - (h / 2);
        const x = window.outerWidth / 2 + window.screenX - (w / 2);
        window.open(`${this.url}`, `_blank`, `toolbar=no,status=no,menubar=no,scrollbars=yes,left=${x},top=${y},width=${w},height=${h},visible=none`, '');
      },

      verificarTokenConectado () {
        if (this.iniciando === false) {
          this.iniciando = true;
          this.listTokens()
          .then(response => {
            this.iniciando = false;
            this.iniciado = true;
            this.demofi_ejecutandose = true;
            this.tokens = response.data.datos;
            this.token_conectado = response.data.datos.length > 0;
          }).catch((error) => {
            this.iniciando = false;
            this.iniciado = true;
            this.token_conectado = false;
            this.demofi_ejecutandose = false;
            console.error(error);
          });
        }
      },
      autenticar () {
        if (this.$refs.form.validate()) {
          this.mostrar_progress = true;
          this.autenticando = true;
          this.$loading.show('Autenticando token');
          return this.login(this.pin)
            .then(respLogin => {
              this.mostrar_progress = false;
              this.autenticando = false;
              this.$loading.hide();
              if (respLogin.data.finalizado === true) {
                this.boton_autenticar_habilitado = false;
                this.autenticado = true;// Obtener certificados
                this.$loading.show('Obteniendo información del token 2');
                return this.listCertificates() // Una ves autenticado actualizamos la lista de certificados
                  .then(respCert => {
                    this.$loading.hide();
                    this.certificados = respCert.datos;
                    this.firmador = respCert.datos[0];
                    this.firmadorSeleccionado = this.firmador.numeroSerie;
                  })
                  .catch(error => {
                    console.log(error);
                  });
              }
            }).catch(error => {
              this.$loading.hide();
              this.$message.error(error.data.mensaje || 'No se pudo acceder al token');
              this.mostrar_progress = false;
              this.autenticando = false;
              this.pin = undefined;
              this.autenticado = false;
              this.boton_autenticar_habilitado = true;
              console.log(error);
              // this.logout();
              this.kill();
            });
        }
      },
      cancelar () { // Cerrando session con el token
        this.logout().then(respLogin => {});
      },
      firmarDocumento (documento, alias, indice, total) {
        const config = {headers: { Authorization: `Bearer ${this.$storage.get('token')}` }};
        this.mostrar_progress = true;
        // console.log('Revisando si es un array', typeof this.solicitud, Array.isArray(this.solicitud));
        // console.log('Revisando el documento', JSON.stringify(documento));
        let promesa = new Promise((resolve, reject) => {
          documento.estado = 'DESCARGANDO';
          this.$loading.show('Obteniendo documento para firmar.' + `<br />${parseInt(indice) + 1} de ${total} documentos.`);
          return this.getFileBase64(documento.url_source_pdf)
          .then(base64Pdf => {
            // console.log('--------> Revisando la obtencion del documento', base64Pdf);
            if (!base64Pdf) throw Error('No se pudo descargar el archivo a firmar');
            documento.pdf_base64 = base64Pdf;
            documento.estado = 'FIRMANDO';
            return this.sign(documento, alias);
          })
          .then(respuestaFirma => {
            respuestaFirma = respuestaFirma.data;
            // console.log('---------> Revisando la respuesta de la firma', respuestaFirma);
            if (!respuestaFirma.datos || !respuestaFirma.finalizado || respuestaFirma.finalizado === false) {
              throw Error('No se pudo firmar el documento, revise que el firmador se encuentra en ejecución.');
            }
            documento.estado = 'ACTUALIZANDO';
            if (!this.solicitud) throw Error('No existe la solicitud');
            const datos = {
              codigo_archivo: documento.codigo_archivo,
              pdf_base64_signed: respuestaFirma.datos.pdf_base64,
              certificado: respuestaFirma.datos.certificado,
              idTramiteDoc: documento.id,
              emailTramiteDoc: documento.tramite_solicitante_email,
              id_archivo: documento.id_archivo
            };
            let url = `${this.$apiUrl}eapostilla/update/${datos.id_archivo}`;
            this.$loading.show('Guardando documento firmado.' + `<br />${parseInt(indice) + 1} de ${total} documentos.`);
            // console.log(datos, url, config);
            return this.$http.post(url, datos, config);
          })
          .then(respuestaActualizacion => {
            // console.log('--------> Revisando la respuesta del backend', respuestaActualizacion);
            documento.estado = 'ACTUALIZADO';
            return resolve(respuestaActualizacion);
          })
          .catch(error => {
            // console.log('Error al firmar el documento', error);
            this.$loading.hide();
            this.mostrar_progress = false;
            documento.estado = 'ERROR_DESCARGA';
            return reject(error);
          });
        });
        return promesa;
      },
      async firmarAsincrono (documentos, indice, alias) {
        if (indice < documentos.length) {
          try {
            let respuesta = await this.firmarDocumento(documentos[indice], alias, indice, documentos.length);
            // console.log('Revisando la repsuesta de la firma de documento', respuesta);
            this.correctos.push({ nombre_archivo: documentos[indice].nombre_archivo, data: respuesta });
          } catch (error) {
            this.errores.push({ nombre_archivo: documentos[indice].nombre_archivo, error });
          }
          indice++;
          await this.firmarAsincrono(documentos, indice, alias);
        } else {
          // console.log('DEMOFI logout');
          console.log('correctos', this.correctos);
          console.log('errores', this.errores);
          this.$store.commit('setLoading', false);
          this.$store.commit('closeModal', 2);
          this.$store.commit('closeModal', 3);
          this.$store.commit('closeModal', 4);
          this.$store.commit('closeModal', 5);
          this.$store.commit('closeModal', 7);
          this.$store.commit('setPin', null);
          this.$loading.hide();
          document.querySelector('div.input-group--selection-controls__ripple').dispatchEvent(new window.Event('click'));
          document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
          this.logout();
          this.firmando = false;
          return;
        }
      },
      async firmar () { // Obtener el documento en blobs
        let aliasSeleccionado = this.firmador.alias;
        this.firmando = true;
        this.firmados = 0;
        this.correctos = [];
        this.errores = [];

        this.$loading.show('Firmando documentos, espere por favor');

        // console.log('Documentos firmar', JSON.stringify(this.solicitudes));

        this.$store.commit('setLoading', true);
        let contador = 0;
        await this.firmarAsincrono(this.solicitudes, contador, aliasSeleccionado);

        if (this.errores.length > 0) {
          this.solicitud.mensajeError = `${this.correctos.length} correctos, ${this.errores.length} con error`;
        }

        if (typeof this.onSuccess === 'function') {
          this.onSuccess(this.solicitud);
        }
      }
    },
    watch: {
      'firmadorSeleccionado': function (val) {
        let seleccionado = {};
        for (let item in this.certificados) {
          if (this.certificados[item].numeroSerie === val) {
            seleccionado = this.certificados[item];
          }
        }
        this.segmento = false;
        this.$nextTick(() => {
          this.segmento = true;
          this.firmador = seleccionado;
        });
      }
    }
  };
</script>

<style lang="scss">
  .demofi-certificado {
    p {
      margin: 0 0 0px;

      em {
        font-size: 0.9rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DemofiGrupal.vue?05233a4a